export default function EssentialGuides() {
  const guides = [
    {
      title: 'Complete Guide to Hiring Contractors in El Paso',
      excerpt: 'Learn the essential steps for vetting contractors, understanding contracts, managing budgets, and ensuring quality work. This comprehensive guide covers licensing requirements, insurance verification, reference checking, and red flags to avoid when hiring home improvement professionals in El Paso.',
      image: 'https://public.readdy.ai/ai/img_res/bcec05c8faf159b2e4543f9259f7befc.jpg',
      readTime: '12 min read',
      category: 'Hiring Tips'
    },
    {
      title: 'El Paso Home Remodeling: What to Expect and How to Budget',
      excerpt: 'Planning a remodeling project requires careful budgeting and realistic expectations. Discover average costs for kitchen and bathroom renovations in El Paso, timeline expectations, how to handle unexpected issues, financing options, and tips for maximizing your investment while maintaining quality and staying within budget.',
      image: 'https://readdy.ai/api/search-image?query=Beautiful%20modern%20kitchen%20remodeling%20project%20in%20El%20Paso%20home%2C%20showing%20elegant%20renovation%20with%20new%20cabinets%20countertops%20and%20appliances%2C%20southwestern%20contemporary%20design%20with%20warm%20lighting%2C%20professional%20interior%20photography%20highlighting%20quality%20finishes%20and%20thoughtful%20design%20details%2C%20bright%20and%20inviting%20space&width=800&height=500&seq=guide-remodel-011&orientation=landscape',
      readTime: '10 min read',
      category: 'Remodeling'
    },
    {
      title: 'Desert Landscaping: Creating Beautiful, Water-Wise Yards',
      excerpt: 'Transform your El Paso yard into a stunning, low-maintenance oasis. This guide explores native plant selection, xeriscaping principles, irrigation efficiency, hardscaping options, and seasonal maintenance tips. Learn how to create outdoor spaces that thrive in our desert climate while conserving water and reducing maintenance costs.',
      image: 'https://readdy.ai/api/search-image?query=Gorgeous%20desert%20landscaping%20in%20El%20Paso%20residential%20front%20yard%2C%20featuring%20colorful%20native%20plants%20succulents%20and%20decorative%20rock%20gardens%2C%20modern%20xeriscaping%20design%20with%20artistic%20hardscaping%20elements%2C%20mountain%20views%20in%20background%2C%20golden%20hour%20lighting%20showcasing%20beautiful%20water-wise%20landscape%20design%20and%20southwestern%20aesthetic&width=800&height=500&seq=guide-landscape-012&orientation=landscape',
      readTime: '8 min read',
      category: 'Landscaping'
    }
  ];

  return (
    <section id="guides" className="py-20 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            El Paso's Essential Home Improvement Guides
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Expert advice, local insights, and practical tips to help you make informed decisions about your home improvement projects. Our guides are specifically tailored to El Paso's unique climate, building codes, and market conditions.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-12">
          {guides.map((guide, index) => (
            <article key={index} className="group bg-white rounded-xl overflow-hidden border border-gray-100 hover:border-teal-500 hover:shadow-xl transition-all duration-300">
              <div className="relative h-56 overflow-hidden">
                <img 
                  src={guide.image} 
                  alt={guide.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute top-4 left-4">
                  <span className="px-3 py-1 bg-teal-600 text-white text-xs font-medium rounded-full">
                    {guide.category}
                  </span>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-teal-600 transition-colors">
                  {guide.title}
                </h3>
                <p className="text-sm text-gray-600 mb-4 leading-relaxed">
                  {guide.excerpt}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-gray-500">{guide.readTime}</span>
                  <a href="#read-more" className="text-sm font-medium text-teal-600 hover:text-teal-700 flex items-center gap-1 whitespace-nowrap">
                    Read Guide
                    <i className="ri-arrow-right-line"></i>
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="bg-gradient-to-br from-teal-50 to-blue-50 rounded-xl p-8 md:p-12">
          <div className="max-w-4xl mx-auto">
            <h3 className="text-3xl font-bold text-gray-900 mb-6 text-center">
              Free Download: Complete Home Remodeling Checklist
            </h3>
            <p className="text-gray-700 mb-8 text-center leading-relaxed">
              Get our comprehensive 50-point checklist covering everything from initial planning and contractor selection to final inspections and warranty documentation. This free resource has helped thousands of El Paso homeowners successfully manage their remodeling projects from start to finish.
            </p>
            <form className="max-w-md mx-auto">
              <div className="flex flex-col sm:flex-row gap-3">
                <input 
                  type="email" 
                  placeholder="Enter your email address" 
                  className="flex-1 px-4 py-3 rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-teal-500 text-sm"
                />
                <button 
                  type="submit"
                  className="px-6 py-3 bg-teal-600 text-white font-medium rounded-lg hover:bg-teal-700 transition-colors whitespace-nowrap text-sm"
                >
                  Download Free
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
